import { render } from "./Home.vue?vue&type=template&id=0c2c940c"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=0c2c940c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__